import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { FONT_SIZE_CHANGE } from "../../Actions/Kiosk/fontSizeChangeAction";
import { FONT_SIZE_RESET } from '../../Actions/Kiosk/fontSizeResetAction';
import storeState, { emptyState } from "../../../utils/storeState";
import { storageKeyFontSize } from "../../../model/StorageKeys";

export default function fontSizeReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  const root = document.querySelector("html");
  if (root) {
    switch(action.type) {
      case FONT_SIZE_CHANGE:
        storeState(storageKeyFontSize, action.payload.fontsize);
        root.style.fontSize = `${action.payload.fontsize}px`;
        return {
          ...state,
          fontsize: action.payload.fontsize
        }
      case FONT_SIZE_RESET:
        emptyState(storageKeyFontSize);
        root.style.fontSize = "";
        return {
          ...state,
          fontsize: null
        }
    }
  }

  return state;
}
